// Templates are discovered automatically from src/templates/<id>/index.js.
// The folder name is the template id returned by the merchant API.
export const DEFAULT_TEMPLATE = 'template1';
const STORAGE_KEY = 'appTemplate';

const context = require.context('@/templates', true, /^\.\/[\w-]+\/index\.js$/);

const registry = context.keys().reduce((acc, key) => {
    const id = key.split('/')[1];
    acc[id] = { ...context(key).default, id };
    return acc;
}, {});

let active = null;

export function resolveTemplateId() {
    const saved = localStorage.getItem(STORAGE_KEY);
    return registry[saved] ? saved : DEFAULT_TEMPLATE;
}

export function activateTemplate(id) {
    active = registry[id] || registry[DEFAULT_TEMPLATE];
    return active;
}

export function getActiveTemplate() {
    return active || activateTemplate(resolveTemplateId());
}

// Persist the template chosen by the merchant API; reload when it changed.
export function syncTemplate(id) {
    if (!id) return;
    const current = localStorage.getItem(STORAGE_KEY) || DEFAULT_TEMPLATE;
    if (id !== current) {
        localStorage.setItem(STORAGE_KEY, id);
        window.location.reload();
    }
}

// Wraps a component so the active template can replace it by name
// via `overrides` in its index.js.
export function overridable(name, component) {
    const override = () => getActiveTemplate().overrides[name];
    if (typeof component === 'function') {
        return () => (override() || component)();
    }
    return override() || component;
}
